export const mappedCountryCodes: any = {
  "US": "United States",
  "CA": "Canada",
  "GB": "United Kingdom",
  "AU": "Australia",
  "DE": "Germany",
  "FR": "France",
  "JP": "Japan",
  "IN": "India",
  "CN": "China",
  "BR": "Brazil",
  "RU": "Russia",
  "ZA": "South Africa",
  "MX": "Mexico",
  "IT": "Italy",
  "ES": "Spain",
  "SE": "Sweden",
  "CH": "Switzerland",
  "NL": "Netherlands",
  "NO": "Norway",
  "FI": "Finland",
  "DK": "Denmark",
  "BE": "Belgium",
  "AT": "Austria",
  "IE": "Ireland",
  "NZ": "New Zealand",
  "SG": "Singapore",
  "HK": "Hong Kong",
  "KR": "South Korea",
  "MY": "Malaysia",
  "TH": "Thailand",
  "PH": "Philippines",
  "ID": "Indonesia",
  "VN": "Vietnam",
  "SA": "Saudi Arabia",
  "AE": "United Arab Emirates",
  "TR": "Turkey",
  "AR": "Argentina",
  "CL": "Chile",
  "CO": "Colombia",
  "PE": "Peru",
  "VE": "Venezuela",
  "NG": "Nigeria",
  "EG": "Egypt",
  "KE": "Kenya",
  "GH": "Ghana",
  "TZ": "Tanzania",
  "UG": "Uganda",
  "DZ": "Algeria",
  "MA": "Morocco",
  "TN": "Tunisia",
  "PT": "Portugal",
  "PL": "Poland",
  "CZ": "Czech Republic",
  "HU": "Hungary",
  "RO": "Romania",
  "GR": "Greece",
  "IS": "Iceland",
  "LU": "Luxembourg",
  "MT": "Malta",
  "CY": "Cyprus",
  "SI": "Slovenia",
  "SK": "Slovakia",
  "HR": "Croatia",
  "BG": "Bulgaria",
  "RS": "Serbia",
  "UA": "Ukraine",
  "BY": "Belarus",
  "KZ": "Kazakhstan",
  "AM": "Armenia",
  "GE": "Georgia",
  "UZ": "Uzbekistan",
  "KG": "Kyrgyzstan",
  "TJ": "Tajikistan",
  "TM": "Turkmenistan",
  "MN": "Mongolia",
  "LK": "Sri Lanka",
  "NP": "Nepal",
  "BD": "Bangladesh",
  "PK": "Pakistan",
  "AF": "Afghanistan",
  "IR": "Iran",
  "IQ": "Iraq",
  "SY": "Syria",
  "JO": "Jordan",
  "LB": "Lebanon",
  "IL": "Israel",
  "PS": "Palestine",
  "QA": "Qatar",
  "KW": "Kuwait",
  "BH": "Bahrain",
  "OM": "Oman",
  "YE": "Yemen",
  "AZ": "Azerbaijan",
};
